const ENDPOINT = 'UPDATEalbuminfo';
function updateAlbumInfo(gateway, params = null) {
    return gateway.get(updateAlbumInfo.endpoint, params);
}
updateAlbumInfo.endpoint = ENDPOINT;

export { updateAlbumInfo as default };
//# sourceMappingURL=updateAlbumInfo.js.map
